import React from 'react';
import { Route, Switch } from 'wouter';
import Homepage from './pages/Homepage';
import Apartment from './pages/Apartment';
import BlogPageHorizontal from './pages/BlogPageHorizontal';

export default function Router() {
    return (
        <Switch>
            <Route path="/" component={Homepage} />
            <Route path="/apartment/:slug" component={Apartment} />
            <Route path="index.php/apartment/:slug" component={Apartment} />
            <Route path="/blog" component={BlogPageHorizontal} />
        </Switch>
    );
}

// export { DataProvider };

// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { Route, Switch, useLocation } from 'wouter';
// import { getApartmentById } from './tools/fetcher';
//
// const DataContext = createContext();
//
// const DataProvider = ({ children }) => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [location] = useLocation();
//
//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             if (location.includes('/apartment/')) {
//                 const slug = location.split('/apartment/')[1];
//                 const data = await getApartmentById(slug);
//                 setData(data);
//             } else {
//                 setData(null);
//             }
//             setLoading(false);
//         };
//         fetchData();
//     }, [location]);
//
//     return (
//         <DataContext.Provider value={{ data, loading }}>
//             {children}
//         </DataContext.Provider>
//     );
// };
//
// export const useData = () => useContext(DataContext);
